import gql from "graphql-tag"

import fullDeal from "./fullDeal"
import fullDealOrder from "./fullDealOrder"
import sagaSnapshotDeal from "./sagaSnapshotDeal"

const fragment = gql`
  fragment fullDealRedemption on DealRedemption {
    date
    dateUnix
    deal {
      ...sagaSnapshotDeal
    }
    fullDeal {
      ...fullDeal
    }
    email
    etag
    isUsed
    order {
      ...fullDealOrder
    }
    pdf
    status
    userId
    user {
      firstname
      lastname
    }
    uuid
    etag
  }
  ${sagaSnapshotDeal}
  ${fullDealOrder}
  ${fullDeal}
`

export const toString = fragment.loc.source.body

export default fragment
